<template>
  <ul class="social">
    <li v-for="(social, i) in socialList" :key="i">
      <a :href="social.link" target="_blank" rel="noreferrer"
        ><img class="svg" :src="social.icon" alt="social"
      /></a>
    </li>
  </ul>
  <!-- End. social -->
</template>

<script>
export default {
  data() {
    return {
      socialList: [
        {
          icon: require("../assets/img/svg/social/linkedin.svg"),
          link: "https://www.linkedin.com/in/ryan-atkins-2a90a91aa/",
        },
        {
          icon: require("../assets/img/svg/social/instagram.svg"),
          link: "https://www.instagram.com/ryanatkinswalking/",
        },
        {
          icon: require("../assets/img/svg/social/email.svg"),
          link: "mailto:raryanatkins59@gmail.com",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
